import React from "react";
import ContentLoader from "react-content-loader"

export default function Loader({className = '', size = 20, type = '', ...props}) {

    const foregroundColor = '#5E6F8B'
    const backgroundColor = '#1F2937'

    if (type === 'table') {
        return (
            <ContentLoader
                style={{ width: '100%' }}
                width={1106}
                height={717}
                speed={2}
                viewBox="0 0 1106 717"
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
                {...props}
            >
                <rect x="51" y="45" rx="7" ry="7" width="1106" height="55" />
                <circle cx="970" cy="123" r="11" />
                <circle cx="1000" cy="123" r="11" />
                <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="115" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="115" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="115" rx="3" ry="3" width="141" height="15" />
                <rect x="55" y="155" rx="3" ry="3" width="1106" height="2" />
                <circle cx="970" cy="184" r="11" />
                <circle cx="1000" cy="184" r="11" />
                <rect x="104" y="175" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="175" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="175" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="175" rx="3" ry="3" width="141" height="15" />
                <rect x="56" y="216" rx="3" ry="3" width="1106" height="2" />
                <circle cx="970" cy="242" r="11" />
                <circle cx="1000" cy="242" r="11" />
                <rect x="104" y="233" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="233" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="233" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="233" rx="3" ry="3" width="141" height="15" />
                <rect x="57" y="274" rx="3" ry="3" width="1106" height="2" />
                <circle cx="970" cy="303" r="11" />
                <circle cx="1000" cy="303" r="11" />
                <rect x="104" y="294" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="294" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="294" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="294" rx="3" ry="3" width="141" height="15" />
                <rect x="58" y="335" rx="3" ry="3" width="1106" height="2" />
                <circle cx="970" cy="363" r="11" />
                <circle cx="1000" cy="363" r="11" />
                <rect x="104" y="354" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="354" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="354" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="354" rx="3" ry="3" width="141" height="15" />
                <rect x="57" y="395" rx="3" ry="3" width="1106" height="2" />
                <circle cx="970" cy="424" r="11" />
                <circle cx="1000" cy="424" r="11" />
                <rect x="104" y="415" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="415" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="415" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="415" rx="3" ry="3" width="141" height="15" />
                <rect x="55" y="453" rx="3" ry="3" width="1106" height="2" />
                <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                <rect x="1104" y="49" rx="3" ry="3" width="2" height="465" />
                <circle cx="970" cy="484" r="11" />
                <circle cx="1000" cy="484" r="11" />
                <rect x="104" y="475" rx="3" ry="3" width="141" height="15" />
                <rect x="273" y="475" rx="3" ry="3" width="299" height="15" />
                <rect x="600" y="475" rx="3" ry="3" width="141" height="15" />
                <rect x="770" y="475" rx="3" ry="3" width="141" height="15" />
                <rect x="55" y="513" rx="3" ry="3" width="1106" height="2" />
                <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
        );
    } else if (type === 'resumeEvent') {
        return (
            <ContentLoader 
                speed={2}
                width={232}
                height={472}
                viewBox="0 0 232 472"
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
                {...props}
            >
                <circle cx="21" cy="13" r="9" />
                <rect x="38" y="7" rx="5" ry="5" width="80" height="12" />
                <rect x="13" y="27" rx="5" ry="5" width="180" height="9" /> 

                <circle cx="21" cy="70" r="9" />
                <rect x="38" y="64" rx="5" ry="5" width="80" height="12" />
                <rect x="13" y="84" rx="5" ry="5" width="130" height="9" />

                <circle cx="21" cy="123" r="9" />
                <rect x="38" y="117" rx="5" ry="5" width="80" height="12" />
                <rect x="13" y="137" rx="5" ry="5" width="150" height="9" />

                <circle cx="21" cy="180" r="9" />
                <rect x="38" y="174" rx="5" ry="5" width="40" height="12" />
                <rect x="13" y="194" rx="5" ry="5" width="90" height="20" />
                <circle cx="140" cy="180" r="9" />
                <rect x="157" y="174" rx="5" ry="5" width="40" height="12" />
                <rect x="132" y="194" rx="5" ry="5" width="90" height="20" />

                <circle cx="21" cy="237" r="9" />
                <rect x="38" y="231" rx="5" ry="5" width="40" height="12" />
                <rect x="13" y="251" rx="5" ry="5" width="90" height="20" />
                <circle cx="140" cy="237" r="9" />
                <rect x="157" y="231" rx="5" ry="5" width="40" height="12" />
                <rect x="132" y="251" rx="5" ry="5" width="90" height="20" />

                <circle cx="21" cy="294" r="9" />
                <rect x="38" y="288" rx="5" ry="5" width="80" height="12" />
                <rect x="13" y="308" rx="5" ry="5" width="165" height="9" />

                <circle cx="21" cy="351" r="9" />
                <rect x="38" y="345" rx="5" ry="5" width="80" height="12" />
                <rect x="13" y="365" rx="5" ry="5" width="150" height="9" />
            </ContentLoader>
        );
    }else {
        return (
            <div className={ className +" w-auto"}>
                <center>
                    <div role="status">
                        <svg
                            aria-hidden="true"
                            className={className + " w-"+size+" h-"+size+" mr-2 text-gray-200 animate-spin dark:text-gray-200 fill-gray-600"}
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                            ></path>
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                            ></path>
                        </svg>
                        <span className="sr-only">Cargando...</span>
                    </div>
                </center>
            </div>
        );
    }
}
